import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AlfredClientConfig } from '../../alfred-client.config';
import { User } from '../../models/user.model';
import { GetUserProfileResponse } from './user.response';

@Injectable({
  providedIn: 'root',
})
export class UserApi {
  private readonly httpClient: HttpClient = inject(HttpClient);
  private readonly config: AlfredClientConfig = inject(AlfredClientConfig);

  /**
   * Fetch the user profile from the alfred api. This endpoint
   * adds some additional data to the generic profile endpoint
   * of the sso.
   */
  public getUserProfile(): Observable<User> {
    const url: string = `${this.config.alfredApiUrl}/profile`;
    const headers: HttpHeaders = new HttpHeaders({
      accept: 'application/json',
    });

    return this.httpClient
      .get<GetUserProfileResponse>(url, { headers: headers })
      .pipe(map((response) => User.fromDto(response)));
  }
}
